import React from 'react';
import { CSVReader } from 'react-papaparse';

const TraitTextCorpusCSVUploader = (
  {
    setDataCSV,
  },
) => {
  const handleOnDrop = (data) => {
    if (!data) {
      setDataCSV(null);
      return;
    }
    const Keys = data[0].data;
    const columns = Keys.map((v, idx) => {
      return {
        id: idx,
        label: v,
        field: v,
      };
    });
    const rows = data.slice(1)
      .map((row) => {
        return row.data;
      })
      .map((row) => {
        return row.map((r, idx) => {
          return {
            Key: Keys[idx],
            Value: r,
          };
        });
      });

    setDataCSV({ Keys, columns, rows });
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err, file, inputElem, reason);
    setDataCSV(null);
  };

  const handleOnRemoveFile = () => {
    setDataCSV(null);
  };

  return (
    <CSVReader
      onDrop={ handleOnDrop }
      onError={ handleOnError }
      addRemoveButton
      onRemoveFile={ handleOnRemoveFile }
      noDrag
    >
      <span>Click here to upload main file</span>
    </CSVReader>
  );
};

export default TraitTextCorpusCSVUploader;
